/**
 * @fileoverview Expand affordance icon that spin-morphs into an arrow on parent `group` hover.
 * @module shared/components/ui/ExpandIcon
 */

import { ReactElement } from 'react'
import { ArrowUpRight, Maximize2 } from 'lucide-react'
import { cn } from '@/shared/utils/cn'

interface ExpandIconProps {
  /** Additional classes for the wrapper */
  className?: string
}

/**
 * Maximize glyph that spins out and morphs into an up-right arrow when an
 * ancestor with the `group` class is hovered. Use inside clickable headers
 * that drill down into a detail view.
 *
 * @component
 */
export function ExpandIcon({ className }: ExpandIconProps): ReactElement {
  return (
    <span className={cn('relative inline-block size-3.5 shrink-0', className)} aria-hidden="true">
      <Maximize2 className="absolute inset-0 size-full text-muted-foreground transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:rotate-90 group-hover:scale-50 group-hover:opacity-0" />
      <ArrowUpRight className="absolute inset-0 size-full text-foreground -rotate-90 scale-50 opacity-0 transition-all duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-hover:rotate-0 group-hover:scale-110 group-hover:opacity-100" />
    </span>
  )
}
